module.exports = __webpack_public_path__ + "media/images/bar_two-a31008f35ffcaa7a76e9fac68338f640.png";